import { Component, Input, OnInit } from '@angular/core';

import { ErrorLevels, ErrorObj } from '@amfam/ui-kit';

@Component({
  selector: 'billing-payment-error-item',
  templateUrl: './billing-payment-error-item.component.html',
  styleUrls: ['../../../../shared/alerts-bar/alert/alert.component.scss'],
  standalone: false
})
export class BillingPaymentErrorItemComponent implements OnInit {
  @Input() errorItem: ErrorObj;

  public currentClasses: any;

  constructor() {}

  ngOnInit() {
    this.currentClasses = {
      'high-alert': this.errorItem.errorLevel === ErrorLevels.HIGH,
      'medium-alert': this.errorItem.errorLevel === ErrorLevels.MEDIUM,
      'low-alert': this.errorItem.errorLevel === ErrorLevels.LOW
    };
  }
}
